module.exports = __webpack_public_path__ + "img/LogoBG.cc401743.png";